import { render } from "./EmployeeProcessed25Liquidations.vue?vue&type=template&id=08613677"
import script from "./EmployeeProcessed25Liquidations.vue?vue&type=script&lang=js"
export * from "./EmployeeProcessed25Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__